import React from 'react';
import MarkdownModal from '../common/MarkdownModal';

interface ReleaseNoteModalProps {
  open: boolean;
  onClose: () => void;
}

const ReleaseNoteModal: React.FC<ReleaseNoteModalProps> = ({ open, onClose }) => {
  return (
    <MarkdownModal
      open={open}
      onClose={onClose}
      title=""
      markdownKey="RELEASE_NOTE" 
    />
  );
};

export default ReleaseNoteModal;
